
export const Contacto = () => {

    return(
        <div>
            Contacto
        </div>
    )
}